import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AddressComponentDef } from '@df/ui/display/address.component.def';

@Component({
    selector: 'checkout-address-model',
    templateUrl: './checkout-address-model.html',
    standalone: true,
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutAddressModelComponent extends AddressComponentDef {
    get firstLine(): string {
        if (this.model) {
            return [this.model.data.firstname + ' ' + this.model.data.lastname]
                .filter(i => !!i)
                .join(', ');
        }
        return '';
    }

    get secondLine(): string {
        if (this.model) {
            return [this.model.data.street_1, this.model.data.street_2]
                .filter(i => !!i)
                .join(', ');
        }
        return '';
    }

    get thirdLine(): string {
        if (this.model) {
            return [this.model.data.city, this.model.regionName, this.model.data.postcode, this.model.countryName]
                .filter(i => !!i)
                .join(', ');
        }
        return '';
    }
}
